import { useFormFieldErrors } from "@/shared/contexts/field-error-context";

interface FormErrorSummaryProps {
  formId: string;
  className?: string;
  /** Override the default summary message. */
  message?: string;
}

/**
 * Top-of-form banner shown when any field error is present for the form.
 * Renders nothing when the form has no errors. Pair with one or more
 * <FieldError /> components next to the relevant inputs.
 *
 * <FormErrorSummary formId="createOrder" />
 */
export const FormErrorSummary = ({ formId, className, message }: FormErrorSummaryProps) => {
  const errors = useFormFieldErrors(formId);
  if (errors.length === 0) return null;

  return (
    <div
      role="alert"
      className={
        className ??
        "rounded-md border border-red-300 bg-red-50 px-3 py-2 text-sm text-red-700 space-y-1"
      }
    >
      <p>{message ?? "Please fix the highlighted fields and try again."}</p>
      {errors.length > 0 && (
        <ul className="list-disc list-inside">
          {errors.map((e, i) => (
            <li key={i}>{e.userMessage}</li>
          ))}
        </ul>
      )}
    </div>
  );
};
